<template>
  <div class="lottery-history-tab">
    <BaseTable :data="lotteryHistoryList">
      <EmptyBlock slot="empty" />
      <BaseElTableColumn :label="$t('member.tab.lotteryHistory.date')" align="center">
        <template slot-scope="scope">
          <div>
            {{ dateFormat(scope.row.createdAt) }}
          </div>
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn prop="awardType" :label="$t('member.tab.lotteryHistory.awardType')" align="center">
        <template slot-scope="scope">
          <div>
            {{ rewardTypes[scope.row.awardType] ? rewardTypes[scope.row.awardType].name : '' }}
          </div>
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn
        :label="$t('member.tab.lotteryHistory.participationName')"
        prop="MemberGame.name"
        align="center"
      >
        <template slot-scope="scope">
          {{ getData(scope.row, 'MemberGame.name') || '' }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn :label="$t('member.tab.lotteryHistory.awardName')" prop="awardName" align="center" />
    </BaseTable>

    <Pagination
      :curPage.sync="tableOptions.page"
      :pageLimit="tableOptions.pageLimit"
      :total="lotteryHistoryCount"
      @pageChange="refresh"
    />
  </div>
</template>

<script>
import EmptyBlock from '@/components/EmptyBlock.vue'
import tableMixin from '@/mixin/table'
import {
  GetMemberGameRecord,
  GetMemberGameRecordCount,
} from '@/api/lottery/memberGameRecord'
import { getData } from '@/utils/object'
import { RewardTypesShowConfig } from '@/config/lottery'

export default {
  name: 'LotteryHistoryTab',
  components: { EmptyBlock },
  mixins: [tableMixin],
  props: ['memberId'],
  data: () => ({
    lotteryHistoryList: [],
    lotteryHistoryCount: 0,
    rewardTypes: RewardTypesShowConfig,
  }),

  async mounted () {
    await this.refresh()
  },
  methods: {
    getData,
    changePage () {},

    async refresh () {
      await this.getMemberGameRecord()
      await this.getMemberGameRecordCount()
    },

    async getMemberGameRecord () {
      const [res, err] = await GetMemberGameRecord({
        shopId: this.shop,
        start: this.pageStartIndex,
        limit: this.tableOptions.pageLimit,
        MemberId: this.memberId,
      })
      if (err) return this.$message.error(err)
      this.lotteryHistoryList = res
    },

    async getMemberGameRecordCount () {
      const [res, err] = await GetMemberGameRecordCount({
        shopId: this.shop,
        start: this.pageStartIndex,
        limit: this.tableOptions.pageLimit,
        MemberId: this.memberId,
      })
      if (err) return this.$message.error(err)
      this.lotteryHistoryCount = res.count
    },
  },
}
</script>

<style lang="postcss" scoped></style>
